import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { RinglessMessageFieldRecordAudio } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldActions/actions/RinglessMessageFieldRecordAudio'
import { RinglessMessageFieldTextToSpeech } from 'widgets/MessageFormFields/RinglessMessageField/ui/RinglessMessageFieldActions/actions/RinglessMessageFieldTextToSpeech'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'
import { RecordAudio } from 'widgets/RecordAudio/ui/RecordAudio'
import { MediaLibraryRinglessSelectButton } from 'widgets/MediaLibrary'
import styles from './styles.module.scss'

export const RinglessMessageFieldActions = observer(() => {
  const {
    isRecordAudioState,
    recordAudioStore,
    onAddAttachmentAudio,
    clearError,
    mediaLibraryConfiguration,
  } = useRinglessMessageFieldContext()

  if (isRecordAudioState) {
    return (
      <div className={classNames(styles.recordAudio)}>
        <RecordAudio
          store={recordAudioStore}
          cancelBtnType={'button'}
          cancelButtonProps={{ typeBtn: 'text' }}
        />
      </div>
    )
  }

  return (
    <div className={classNames(styles.wrap)}>
      <RinglessMessageFieldRecordAudio />
      <RinglessMessageFieldTextToSpeech />
      <MediaLibraryRinglessSelectButton
        onAddAttachment={onAddAttachmentAudio}
        onClick={clearError}
        mediaLibraryConfiguration={mediaLibraryConfiguration || undefined}
      />
    </div>
  )
})
